import { CircularProgress, Typography } from "@mui/material"
import { useFetch } from "../../../hooks/useFetch"
import CustomerForm from "./CustomerForm"

export default function CustomerEditForm({mutateList, customer_id, handleClose}){

    const {data, isLoading, error, mutate} = useFetch(`person/${customer_id}`)

    if(isLoading) return <CircularProgress />
    if(error) return <Typography>{error.message}</Typography>
    
    return <>
        <CustomerForm data={data} mutate={mutate}  mutateList={mutateList} handleClose={handleClose} />
    </>
}